/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './BuyersSection.module.scss';

type Translate = (key: string) => string;

type Job = {
  team: string;
  title: string;
  description: string;
};

const getJobs = (t: Translate): Job[] => [
  {
    team: t('Compliance & KYB teams'),
    title: t('Find the ultimate parent — then the UBOs behind it'),
    description: t(
      'Resolve any counterparty to its global ultimate, then pull the beneficial owners and directors behind that parent. One chain, from local entity to the people who actually control it.',
    ),
  },
  {
    team: t('Sales & RevOps'),
    title: t('Uncover the group behind a small account'),
    description: t(
      'A minor account may sit inside a multi-billion group. Linkage reveals the full structure behind every customer — so you spot expansion opportunities, price at group level, and plan territories accurately.',
    ),
  },
  {
    team: t('Credit & Risk teams'),
    title: t('Know your real exposure to a group'),
    description: t(
      "Every entity's exposure rolls up to one ultimate parent — limits apply to the group you're actually lending to, not one company in it.",
    ),
  },
  {
    team: t('Data & Product teams'),
    title: t('Turn 40 duplicate records into one customer'),
    description: t(
      'One persistent group key across CRM, ERP, and risk systems — the join key that makes deduplication and enrichment finally work.',
    ),
  },
];

export const BuyersSection = () => {
  const { t } = useInt();

  return (
    <Section background="#f6f7f9" className={styles.root}>
      <div className={styles.head}>
        <TitleBlock
          title={t('Who uses Corporate Linkage — and what they use it for')}
          description={t(
            'Compliance, sales, credit, and data teams all pull from the same hierarchy — each for a different job.',
          )}
        />
      </div>

      <div className={styles.grid}>
        {getJobs(t).map((job) => (
          <div key={job.team} className={styles.job}>
            <div className={styles.team}>{job.team}</div>
            <div className={styles.jobTitle}>{job.title}</div>
            <p className={styles.description}>{job.description}</p>
          </div>
        ))}
      </div>
    </Section>
  );
};
